import { render, staticRenderFns } from "./CardAdminLideres.vue?vue&type=template&id=7aa7dd47&scoped=true"
import script from "./CardAdminLideres.vue?vue&type=script&lang=js"
export * from "./CardAdminLideres.vue?vue&type=script&lang=js"
import style0 from "./CardAdminLideres.vue?vue&type=style&index=0&id=7aa7dd47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa7dd47",
  null
  
)

export default component.exports